import React from 'react';
import { useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import { primaryButtonBackground } from '../../constants/Colors';
import { mypageHeader, mypageHeaderTitle } from '../../constants/Location';
import { screenType } from '../../constants/enum';

const styles = {
  mypageHeader,
  mypageHeaderTitle
};

const BootstrapButton = styled(Button)(
  Object.assign(primaryButtonBackground, {
    '@media screen and (max-width:960px)': { height: '30px' }
  })
);

interface Props {
  screen: number;
}

export default function GivenListHeader(props: Props): JSX.Element {
  const { screen } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      <Typography component="div" sx={styles.mypageHeader}>
        <Typography sx={styles.mypageHeaderTitle}>
          {t('given.givenlist')}
        </Typography>
        <BootstrapButton
          variant="contained"
          disableRipple
          onClick={() => {
            if (screen === screenType.client) {
              navigate('/client/mypage/issue/edit?type=add');
            } else if (screen === screenType.agent) {
              navigate('/agent/mypage/issue/edit?type=add');
            }
          }}
        >
          ＋ {t('given.register')}
        </BootstrapButton>
      </Typography>
    </>
  );
}
